import { createContext } from "react";

const RoutesContext = createContext({ route: [] });

export { RoutesContext };
